export default __webpack_public_path__ + "static/media/syncLogo.19f8df8d.svg";